import React from 'react';
import { HeaderWrapper } from './ChatHeader.styles';

const ChatHeader : React.FC = () => {
  return (
    <HeaderWrapper>
      Chat
    </HeaderWrapper>
  );
};

export default ChatHeader;